import React, { useState } from "react";
import { useAppContext } from "../../AppProvider";
import { useRejectOrderContext } from "./providers/Reject";
import ButtonUtility from "../../Components/Buttons/Utility";
import ButtonDelete from "../../Components/Buttons/Delete";
import { useHandlerOrderContext } from "./providers/Handler";
import InputIcon from "../../Components/Inputs/InputIcon/InputIcon";

const Reject: React.FC = () => {
  const { dictionary } = useAppContext();
  const { modal } = useHandlerOrderContext();
  const { data, callback, loader, rejectOrders } = useRejectOrderContext();
  const [motivation, setMotivation] = useState("");

  return (
    <React.Fragment>
      <div className="row">
        <div className="col">
          <h3 className="text-center">{modal.title}</h3>
          <label className="label-4 text-center">
            {data?.length && data.length > 1
              ? dictionary.messages.are_you_sure_you_want_to_continue
              : dictionary.messages.are_you_sure_you_want_to_continue}
          </label>
        </div>
      </div>
      <div className="row mt-2 mb-3">
        <div className="col">
          <label className="label-2">{dictionary.words.motivation} *</label>
          <InputIcon
            name="motivation"
            value={motivation || ""}
            type="text"
            onChange={({ target }) => {
              setMotivation(target.value as string);
            }}
            max={200}
          />
        </div>
      </div>
      <div className="d-flex">
        <ButtonUtility
          className="w-50 me-2"
          onClick={() => {
            if (callback) {
              callback();
            }
          }}
        >
          {dictionary.actions.cancel}
        </ButtonUtility>
        <ButtonDelete
          className="w-50"
          onClick={() => rejectOrders(motivation)}
          disabled={loader || !motivation}
          loading={loader}
          icon={false}
        >
          {dictionary.status.rejected_sm}
        </ButtonDelete>
      </div>
    </React.Fragment>
  );
};

export default Reject;
